import { render, staticRenderFns } from "./CustomSettingPage.vue?vue&type=template&id=74691ea9"
import script from "../../../controllers/custom/setting/custom-setting-page.js?vue&type=script&lang=js&external"
export * from "../../../controllers/custom/setting/custom-setting-page.js?vue&type=script&lang=js&external"
import style0 from "./CustomSettingPage.vue?vue&type=style&index=0&id=74691ea9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports